import React from 'react';
import { createRoot } from 'react-dom/client';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import App from './App';
import { ptBR } from '@mui/material/locale';

const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#36A9E0',
      },
      secondary: {
        main: '#6D8891',
      },
    },

    typography: {
      //fontFamily: 'Inter, Arial, sans-serif',
      fontFamily: 'Roboto, Arial, sans-serif',
      fontSize: 11,
    },

    components: {
      MuiDataGrid: {
        localeText: ptBR.components.MuiDataGrid,
      },
    },
  },
  ptBR
);

const root = document.getElementById('root');
createRoot(root).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
